"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var countdown_1 = tslib_1.__importDefault(require("../../countdown/countdown"));
var date_1 = require("../../../../common/utils/date");
var build_url_1 = require("../../../../common/utils/url/build-url");
var open_popup_1 = tslib_1.__importDefault(require("../../../../common/utils/open-popup"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var live_label_scss_1 = tslib_1.__importDefault(require("./live-label.scss"));
var LiveIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/LiveIcon"));
var ScheduledBigIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ScheduledBigIcon"));
var ScheduledSmallIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ScheduledSmallIcon"));
var inline_icon_1 = tslib_1.__importDefault(require("../../inline-icon/inline-icon"));
var defaultDateFormat = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
};
var toShortISOWithoutDelimiters = function (datetime) {
    return new Date(datetime).toISOString().replace(/-|:|\.\d+/g, '');
};
var LiveLabel = /** @class */ (function (_super) {
    tslib_1.__extends(LiveLabel, _super);
    function LiveLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openGoogleCalendarEvent = function (event) {
            var _a = _this.props, startTime = _a.startTime, liveText = _a.liveText, videoTitle = _a.videoTitle;
            var startTimeShortISO = toShortISOWithoutDelimiters(startTime);
            var url = (0, build_url_1.buildUrl)('https://www.google.com/calendar/event', {
                action: 'TEMPLATE',
                dates: "".concat(startTimeShortISO, "/").concat(startTimeShortISO),
                text: videoTitle,
                location: '',
                details: liveText,
            });
            (0, open_popup_1.default)(url);
            event.stopPropagation();
        };
        return _this;
    }
    LiveLabel.prototype.renderLiveLabel = function () {
        var _a, _b, _c;
        var _d = this.props, liveText = _d.liveText, pendingLiveText = _d.pendingLiveText, isPendingLiveStream = _d.isPendingLiveStream, className = _d.className, isRTL = _d.isRTL;
        var label = isPendingLiveStream ? pendingLiveText : liveText;
        var liveStreamLabelClassNames = (0, classnames_1.default)(live_label_scss_1.default.live, className, (_a = {},
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        var liveIconClassNames = (0, classnames_1.default)(live_label_scss_1.default['live-icon'], (_b = {},
            _b[live_label_scss_1.default.rtl] = isRTL,
            _b[live_label_scss_1.default.ltr] = !isRTL,
            _b));
        var liveTextClassNames = (0, classnames_1.default)(live_label_scss_1.default['live-text'], (_c = {},
            _c[live_label_scss_1.default.rtl] = isRTL,
            _c[live_label_scss_1.default.ltr] = !isRTL,
            _c));
        return (react_1.default.createElement("div", { "data-hook": "live-stream-label", className: liveStreamLabelClassNames, role: "note", "aria-label": label },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(LiveIcon_1.default, null), className: liveIconClassNames }),
            react_1.default.createElement("span", { className: liveTextClassNames }, label)));
    };
    LiveLabel.prototype.renderScheduledLabel = function () {
        var _a, _b, _c, _d;
        var _e = this.props, className = _e.className, liveText = _e.liveText, addReminderText = _e.addReminderText, reminderAriaLabel = _e.reminderAriaLabel, thumbnailWidth = _e.thumbnailWidth, isFocusable = _e.isFocusable, isRTL = _e.isRTL;
        var ScheduledIcon = thumbnailWidth < 500 ? ScheduledSmallIcon_1.default : ScheduledBigIcon_1.default;
        var scheduledLabelClassNames = (0, classnames_1.default)(live_label_scss_1.default.scheduled, className, (_a = {},
            _a[live_label_scss_1.default.rtl] = isRTL,
            _a[live_label_scss_1.default.ltr] = !isRTL,
            _a));
        var scheduledIconClassNames = (0, classnames_1.default)(live_label_scss_1.default['scheduled-icon'], (_b = {},
            _b[live_label_scss_1.default.rtl] = isRTL,
            _b[live_label_scss_1.default.ltr] = !isRTL,
            _b));
        var scheduledTextClassNames = (0, classnames_1.default)(live_label_scss_1.default['scheduled-text'], (_c = {},
            _c[live_label_scss_1.default.rtl] = isRTL,
            _c[live_label_scss_1.default.ltr] = !isRTL,
            _c));
        var reminderClassNames = (0, classnames_1.default)(live_label_scss_1.default.reminder, (_d = {},
            _d[live_label_scss_1.default.rtl] = isRTL,
            _d[live_label_scss_1.default.ltr] = !isRTL,
            _d));
        return (react_1.default.createElement("div", { "data-hook": "scheduled-label", className: scheduledLabelClassNames, "aria-label": this.getScheduledAriaLabel(), role: "region", tabIndex: isFocusable ? 0 : -1 },
            react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(ScheduledIcon, null), className: scheduledIconClassNames }),
            react_1.default.createElement("span", { className: scheduledTextClassNames }, "".concat(liveText, ": "),
                this.renderScheduledTime()),
            react_1.default.createElement("span", { onClick: this.openGoogleCalendarEvent, tabIndex: isFocusable ? 0 : -1, role: "link", className: reminderClassNames, "aria-label": reminderAriaLabel }, addReminderText)));
    };
    LiveLabel.prototype.getScheduledAriaLabel = function () {
        var _a = this.props, startTime = _a.startTime, scheduledSoonAriaLabel = _a.scheduledSoonAriaLabel, scheduledAriaLabel = _a.scheduledAriaLabel;
        return startTime - Date.now() < date_1.MILLISECONDS.ONE_DAY
            ? scheduledSoonAriaLabel
            : scheduledAriaLabel;
    };
    LiveLabel.prototype.renderScheduledTime = function () {
        var _a = this.props, startTime = _a.startTime, startsInAriaLabel = _a.startsInAriaLabel, locale = _a.locale, dateFormat = _a.dateFormat, isFocusable = _a.isFocusable;
        if (startTime - Date.now() > date_1.MILLISECONDS.ONE_DAY) {
            return new Date(startTime).toLocaleString(locale, dateFormat);
        }
        return (react_1.default.createElement(countdown_1.default, { until: startTime, titlePrefix: startsInAriaLabel, isFocusable: isFocusable }));
    };
    LiveLabel.prototype.render = function () {
        var _a = this.props, isStreaming = _a.isStreaming, isScheduled = _a.isScheduled;
        if (isStreaming) {
            return this.renderLiveLabel();
        }
        if (isScheduled) {
            return this.renderScheduledLabel();
        }
        return null;
    };
    LiveLabel.defaultProps = {
        dateFormat: defaultDateFormat,
    };
    return LiveLabel;
}(react_1.default.Component));
exports.default = LiveLabel;
//# sourceMappingURL=live-label.js.map